import React from 'react';
import { Row, Col } from 'antd';
import ProgressBar from '../../Progress';

const SkillsProgress = () => (
  <div>
    <h2>My Skills</h2>
    <Row gutter={[20, 20]}>
      <Col xs={24} sm={24} md={12}>

        <ProgressBar
          percent={80}
          text="Python"
        />
        <ProgressBar
          percent={70}
          text="Node.js"
        />
        <ProgressBar
          percent={65}
          text="Android Development"
        />
        <ProgressBar
          percent={50}
          text="C++"
        />
      </Col>
      <Col xs={24} sm={24} md={12}>
        <ProgressBar
          percent={75}
          text="Java"
        />
        <ProgressBar
          percent={75}
          text="SQL"
        />
        <ProgressBar
          percent={65}
          text="React"
        />
        <ProgressBar
          percent={70}
          text="Latex"
        />
      </Col>
    </Row>
  </div>
);

export default SkillsProgress;
